import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Header from '../_components/Header';
import backIcon from '../_assets/imgs/back.png';
import { jobsActions } from '../_actions';
import Spinner from '../_components/Spinner';
import { ToastContainer } from 'react-toastify';

import Person from '../_assets/new/detail/person.png';
import workOutlin from '../_assets/new/detail/work_outline.png';
import Phone from '../_assets/new/detail/phone.png';

function DetailApplicant() {
  const dispatch = useDispatch();
  const { key } = useParams();
  const { detailJob, isLoading } = useSelector((state) => state.jobsForm);

  useEffect(() => {
    dispatch(jobsActions.detailJobAction(key));
  }, [dispatch, key]);

  return (
    <div className="detail-jobs">
      <Header />
      <ToastContainer autoClose={false} theme="colored" />

      <div className="container">
        <div className="row">
          <div className="col-md-3">
            <div className="text-right">
              <Link to="/applicants">
                <span className="back">
                  <img src={backIcon} alt="" />
                  Regresar al inicio
                </span>
              </Link>
            </div>
          </div>
          <div className="col-md-6">
            {!isLoading ? setDetail(detailJob) : <Spinner />}
          </div>
        </div>
      </div>
    </div>
  );
}

function setDetail(detailJob) {
  if (!detailJob) return;

  function getBirthday(date) {
    const newDate = new Date(date);
    const currentDate = new Date();
    return parseInt((currentDate.getTime() - newDate.getTime()) / 31556900000);
  }

  function getExperience(data) {
    if (data && data.length) {
      return data.map((el) => {
        return (
          <div className="box-experience" key={el.id}>
            <div className="experience-title">{el.company}</div>
            <div className="experience-job"> {el.job} </div>
            <div className="row">
              <div className="col-md-6">
                Salario mensual recibido: <b>${el.salary}</b>
              </div>
              <div className="col-md-6">
                Tipo de empleo: <b>{el.job_type}</b>
              </div>
            </div>
            <div className="experience-date">
              {el.start_date} - {el.end_date}
            </div>
            <div className="experience-description">{el.description}</div>
          </div>
        );
      });
    }

    return 'No disponible';
  }

  function getAcademicData(data) {
    if (data && data.length) {
      return data.map((el) => {
        return (
          <div className="box-experience" key={el.id}>
            <div className="experience-title">{el.degree}</div>
            <div className="experience-job"> {el.academic_situation} </div>
            <div className="experience-description">{el.skills}</div>
          </div>
        );
      });
    }

    return 'No disponible';
  }

  return (
    <div className="job-detail">
      <img
        className="principal"
        src={detailJob.candidate_data?.profile_image}
      />
      <h2 className="marginless title">
        {detailJob.first_name} {detailJob.last_name}
      </h2>
      <div>
        <span className="text"> {detailJob.candidate_data?.profession}</span>
      </div>
      <div className="row job-important">
        <div className="col-md-6">
          <div className="text">
            <img src={workOutlin} /> {detailJob.email || '-'}
          </div>
          <div className="text">
            <img src={Phone} />
            {detailJob.phone || '-'}
          </div>
          <div className="text">
            {' '}
            Curp: {detailJob.candidate_data?.curp || '-'}
          </div>
        </div>
        <div className="col-md-6">
          <div className="text">
            <img src={Person} /> Disponibilidad:{' '}
            {detailJob.candidate_data?.currently_working ? 'Si' : 'No'}{' '}
          </div>
          {/* <div className='text'><img src={workOutlin} />  </div> */}
          <div className="text">
            <img src={Person} /> {detailJob.candidate_data?.genere} -{' '}
            {getBirthday(detailJob.candidate_data.birthdate)} años
          </div>
        </div>
      </div>

      <h3 className="subtitle">PUESTO DESEADO</h3>
      <div className="row">
        <div className="col-md-6">
          <div className="text">
            {detailJob.candidate_data.expected_job.job}
          </div>
          <div className="text">
            Salario pretendido: ${detailJob.candidate_data.expected_job.salary}{' '}
            mxn
          </div>
        </div>
        <div className="col-md-6">
          <div className="text">
            {detailJob.candidate_data.expected_job.experience} años de
            experiencia
          </div>
          <div className="text">
            {detailJob.candidate_data.expected_job.type}
          </div>
        </div>
      </div>

      <h3 className="subtitle">EXPERIENCIA PREVIA</h3>
      <div className="text">{getExperience(detailJob.experience)}</div>
      <h3 className="subtitle">DOMICILIO</h3>
      <div className="text">
        {detailJob.address.street_address_1} {detailJob.address.neighborhood}{' '}
        {detailJob.address.city} {detailJob.address.state}{' '}
        {detailJob.address.zip_code}
      </div>
      <h3 className="subtitle">GRADO DE ESTUDIOS</h3>
      <div className="text">{getAcademicData(detailJob.academic_data)}</div>
      {/* <h3 className='subtitle'>CONOCIMIENTOS Y HABILIDADES REQUERIDOS</h3>
            <div className='text'>
                {detailJob.knowledge || '-'}
            </div>
            <h3 className='subtitle'>PRESTACIONES</h3>
            <div className='text'>
                {detailJob.benefits || '-' }
            </div> */}
    </div>
  );
}

export { DetailApplicant };
